import { useState, useEffect, type FC, type ReactElement } from 'react';
import styles from './ScrollLock.scss';

type Props = {
    isLocked?: boolean;
    children?: ReactElement;
};

export const ScrollLock: FC<Props> = ({ isLocked, children }) => {
    const [scrollY, saveScrollY] = useState(0);

    useEffect(() => {
        const body = document.body;
        if (isLocked) {
            saveScrollY(window.pageYOffset);
            body.classList.add(styles.noScroll);
            /**
             * This component is primaraly used with an overlay. There are cases where the overlay can be triggered
             * by an input element. In that case iOS safari opens up the keyboard and in certain cases introduces
             * a scrollbar. This causes the overlay element to scroll down. The goal is to keep the scroll position
             * always at the top and we force it by calling `scrollTo`.
             */
            window.scrollTo(0, 0);
        } else {
            body.classList.remove(styles.noScroll);
            window.scrollTo(0, scrollY);
        }
    }, [isLocked, scrollY]);

    return children || null;
};
